import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { OffersDataService } from '../services/offers-data.service';
import { useAsgActions } from '../../shared/src/hooks/use-asg-actions.hook';

export const useHomepageStyles = () => {
    const { globalComponentsVisibility, pagePurpose } = OffersDataService.getOffersData();
    const { setHeaderComponentsVisibility } = useAsgActions();
    const dispatch = useDispatch();

    useEffect(() => {
        const header = document.querySelector('#asg-vertical-header');
        const quickLinks = document.querySelector('.quick-links-container');
        const isQuickLinksAvailable = globalComponentsVisibility?.footer?.quickLinks;
        const isLanding = pagePurpose === 'landing';
        const isActiveHeaderAvailable = isLanding && !globalComponentsVisibility?.header;

        if (!isQuickLinksAvailable && isLanding) {
            quickLinks.style.display = 'none';
        }

        document.body.classList.add('homepage');

        isLanding && dispatch(setHeaderComponentsVisibility(globalComponentsVisibility));

        const addActiveClassToHeader = () => {
            if (isActiveHeaderAvailable) {
                return;
            }

            if (window.scrollY > 1) {
                header.classList.add('active-header');
            } else {
                header.classList.remove('active-header');
            }
        };

        window.addEventListener('scroll', addActiveClassToHeader);

        return () => {
            document.body.classList.remove('homepage');
            header.classList.remove('active-header');
            window.removeEventListener('scroll', addActiveClassToHeader);
            quickLinks.style.display = 'flex';
        };
    }, []);
};
